import { z } from 'zod';
/**
 * Canonical per-kind `channel_account.config` schemas — the single source the
 * adapter (`channel-gmail`/`channel-web-form`), runtime wiring (`app-runtime`)
 * and the admin CRUD contracts (`admin-contracts`, which layers `.meta()` UI
 * labels on top) all derive from. Error messages here are the admin-facing
 * strings; validation semantics are identical for every consumer.
 */
/** Mirrors the Postgres `channel_account_status` enum in `db/schema.sql`. */
export const ChannelAccountStatusSchema = z.enum([
    'active',
    'paused',
    'reauth_required',
    'error',
    'pending_oauth',
]);
export const GmailChannelConfigSchema = z.object({
    clientId: z.string().min(1, 'Required'),
    clientSecret: z.string().min(1, 'Required'),
    refreshToken: z.string().min(1, 'Required'),
    emailAddress: z.string().email('Enter a valid email address'),
    /** Polling cadence for `history.list`. 5s floor, 60s ceiling. */
    pollIntervalMs: z.number().int().min(5_000).max(60_000).default(10_000),
    /** Optional Workspace send-as alias used as the MIME `From` on replies. */
    sendFromAlias: z.string().email('Enter a valid email address').optional(),
    /** Optional display name for the MIME `From` header (e.g. `WIT LAB`). */
    fromName: z.string().min(1).optional(),
});
export const WebFormChannelConfigSchema = z.object({
    recipientHint: z.string().email('Enter a valid email address'),
    webhookSecret: z.string().min(1, 'Required'),
    allowAttachments: z.boolean().default(false),
});
/**
 * Keys of each kind's config that are secret: encrypted at rest
 * (`encryptConfigSecrets`) and redacted for callers without
 * `channels.read_secrets`.
 */
export const CHANNEL_SECRET_KEYS = {
    gmail: ['clientSecret', 'refreshToken'],
    web_form: ['webhookSecret'],
};
//# sourceMappingURL=channel-config.js.map